<template>
    <div class="client-detail" v-loading="btnLoad.homeBtn">
        <div class="title-1"> <h3>基本信息</h3></div>
       
        <el-form :model="dataForm" ref="dataForm" :rules="rules" label-position="top">
            <el-row gutter="20">
                <el-col :span="8">
                    <el-form-item label="客户全称" prop="name">
                        <el-input v-model="dataForm.name" :disabled="isDisable" placeholder="请输入客户全称" @blur="nameBlur" clearable/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="地址区域" prop="areaIdDesc">
                        <ab-address v-model="dataForm.areaIdDesc" :disabled="isDisable" @change="selectArea" ref="area"></ab-address>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="详细地址" prop="address">
                        <el-input v-model="dataForm.address" :disabled="isDisable" placeholder="请输入详细地址" clearable/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="社会信用代码" prop="uscCode" :rules="[
                        {required: required, message: '请输入社会信用代码', trigger: ['change', 'blur']}
                    ]">
                        <el-input v-model="dataForm.uscCode" :disabled="isDisable" placeholder="请输入社会信用代码" clearable/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-divider style="margin:10px 0 40px;border-top:1px solid #F0F2F5"/>

        <div class="title-3">
            <h3>收货信息</h3>
        </div>

        <vxe-table 
            v-if="reload"
            ref="elxEditable"
            border 
            show-overflow
            resizable 
            keep-source
            auto-resize
            max-height="520"
            :data="vuexData" 
            :edit-config="{trigger: 'click', mode: 'row', showUpdateStatus: true,icon: 'abcd'}" 
            :row-class-name="rowStyle"
            :cell-class-name="cellStyle"
            :edit-rules="vuexrules"
        >
            <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>

            <vxe-column field="company" title="收货公司" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template v-slot:edit="{ row }">
                    <vxe-input v-model="row.company" :disabled="inTableDisabled(row)" type="text" placeholder="请输入收货公司"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="linkman" title="联系人" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.linkman" :disabled="inTableDisabled(row)" type="text" placeholder="请输入联系人姓名"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="mobile" title="联系电话" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.mobile" :disabled="inTableDisabled(row)" type="text" placeholder="请输入联系电话"></vxe-input>
                </template>
            </vxe-column>
        
            <vxe-column field="areaIdDesc" title="收货区域" :edit-render="{}">
                <template v-slot="{row}">
                    <span>{{row.areaDesc}}</span>
                </template>
                <template v-slot:edit="{ row }">
                    <ab-address 
                        v-model="row.areaIdDesc" 
                        @change='(val, valdetail)=>{return adressChange(val, valdetail, row)}' 
                        placeholder= "请选择收货区域"
                        :disabled="inTableDisabled(row)"
                    ></ab-address>
                </template>
            </vxe-column>

            <vxe-column field="takeAddress" title="收货地址" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.takeAddress" :disabled="inTableDisabled(row)" type="text" placeholder="请输入收货地址" @blur="takeAddressChangeInTable($event, row)"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="isDefault" title="默认地址">
                <template #default="{ row }" >
                    <el-switch v-model="row.isDefault" :disabled="inTableDisabled(row)" :active-value="1" :inactive-value="0" @change="switchDefault(row)"/>
                </template>
            </vxe-column>

            <vxe-column field="addressDescription" title="地址说明" :edit-render="{}">
                <template v-slot="{ row }">
                    <span>{{ row.addressDesc }}</span>
                    <span>{{ row.addressDescriptionDesc }}</span>
                </template>
                <template v-slot:edit="{ row }">
                    <vxe-select :disabled="inTableDisabled(row)" v-model="row.addressDescription" placeholder="请选择" transfer @change="(obj)=>{ return changeType(obj, row)}">
                        <vxe-option v-for="(option, idx) in addressDescriptionOptions" :key="idx" :label="option.desc" :value="option.value"></vxe-option>
                    </vxe-select>
                </template>
            </vxe-column>

            <vxe-column field="address" title="操作">
                <template #default="{rowIndex , row}">
                    <el-button link type="primary" @click="editRow(row)" v-if="!row.showSubmit && dataForm.approvalStatusDesc === '已核准' && ['已提交', '已审核'].includes(dataForm.statusDesc)">修改</el-button>
                    <el-button link type="primary" @click="confirmRow(row)" v-if="row.showSubmit && ['已提交', '已审核'].includes(dataForm.statusDesc)">提交</el-button>
                    <el-button link type="primary" :disabled="inTableDisabled(row, true)" @click="removeRow(row, rowIndex)" style="color:#FF0000">删除</el-button>
                </template>
            </vxe-column>
        </vxe-table>
        <div class="addCargo" >
            <span @click="addShipments"><ab-svg name="add"></ab-svg> 新增一行</span>
        </div>

        <!-- <ab-upload :params="uploadParams" ref="fileUpload" @update-billsId="updateBillsId"></ab-upload> -->

        <ab-footer>
            <el-button @click="back">返回</el-button>
            
            <el-button type="primary" @click="revise" :loading="btnLoad.handLoad" v-if="!routeQuery.id">提交</el-button>
        </ab-footer>
    </div>
</template>

<script>
export default {
    name: 'client-detail',
    data() {
        const stringLT20 = (rule, value, callback) => {
            if (!/^[A-Za-z0-9]{0,20}$/.test(value)) {
                callback(new Error('请输入数字或字母，最大长度20位'))
            } else {
                callback()
            }
        }
        return {
            dataForm: {},
            vuexData:[],
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'change' },
                    { max: 100, message: '最大长度100个字符', trigger: 'change' },
                ],
                areaIdDesc: [
                    { required: true, message: '请选择地址区域', trigger: 'change'}
                ],
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur'},
                    { max: 200, message: '详细地址最大长度200个字符', trigger: 'blur'}
                ],
                uscCode: [
                    { validator: stringLT20, trigger: 'blur'  }
                ]
            },
            //路由参数
            routeQuery: {},
            // 地址说明
            addressDescriptionOptions: [],
            // 附件管理
            uploadParams: {
                coreBillIds: '',
                coreBillNumbers: '',
                sourceBillId: '',
                sourceBillNumber: '',
                sourceBillType: 'Customer',
                billType: '',
                items: [
                    {
                        title: '身份证件',
                        attachType: '011',
                        required: true,
                        errorTips: '请上传身份证件'
                    },
                ]
            },
            btnLoad: {
                handLoad: false,
                homeBtn: false,
            },
            vuexrules:{
                company: [
                    { required: true, message: '请输入提货公司' }
                ],
                linkman: [
                    { required: true, message: '请输入联系人'},
                    { validator: ({ cellValue }) => {
                            if (cellValue) {
                                if (cellValue.length > 50) {
                                    return new Error('联系人最大长度50位')
                                }
                            }
                        }
                    }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { validator: ({ cellValue }) => {
                            if (cellValue) {
                                if (!/^[\d\s]+$/.test(cellValue)) {
                                    return new Error('请输入正确的手机号码')
                                }
                            }
                        }
                    }
                ],
                areaIdDesc: [
                    { required: true, message: '请选择收货区域', trigger: 'blur' }
                ],
                isDefault: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                addressDescription: [
                    { required: true, message: '请选择地址说明', trigger: 'blur' }
                ]
            },
            reload: true,
            required: false
        }
    },
    mounted() {
        this.getAddressList()
    },
    activated(){
        this.routeQuery = Object.keys(this.$route.query).length ? this.$route.query : this.routeQuery
        if (this.routeQuery.cache) {
            
        } else {
            this.routeQuery.cache = true
        }
        this.init()
    },
    deactivated() {
        this.uploadParams.sourceBillId = ''
    },
    computed: {
        isDisable () {
            return ![undefined, '已保存'].includes(this.dataForm.statusDesc)
        }
    },
    methods: {    
        // 修改分录
        editRow (row) {
            row.showSubmit = true
        },
        // 判断行状态
        inTableDisabled (row, isButton = false) {
            if (row.showSubmit) return false
            if (this.isSubmit) {
                for (let item of this.customerTableData) {
                if (!item.entryPrincipalId) {
                    if (item !== row) {
                    return true
                    }
                }
                }
                if (row.entryPrincipalId && !isButton) {
                    return true
                }
                return false
            }
            return this.isDisable
        },
        //获取详情
        init () {
            this.vuexData = []
            this.dataForm = {}
            if (this.routeQuery.id) {
                this.btnLoad.homeBtn = true
                this.uploadParams.sourceBillId = this.routeQuery.id
                this.$get('/bas/client/basCustomer/get', { id: this.routeQuery.id }).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.dataForm = data.result || {}
                        this.vuexData = data.result.linkmanList || []
                        this.btnLoad.homeBtn = false
                    }
                }).finally(()=>{
                    this.$nextTick(() => {
                        this.btnLoad.homeBtn = false
                    })
                })
            }
        },
        getAddressList(){
            this.$post('/bas/basCustomer/addressDescription').then(({ data }) => {
                if (data.code === 'C0000') {
                    this.addressDescriptionOptions = data.result.map(item => {
                        item.value = Number(item.value)
                        return item
                    })
                }
            })
        },
        addShipments(){
            for (let item of this.vuexData) {
                if (!item.entryPrincipalId) {
                    return this.$message.warning('同时只能存在一条待提交数据')
                }
            }
            let row = {
                addressType: '01',
                addressDescription: 2, // 客户地址
                addressDescriptionDesc: '客户地址',
                isDefault: 0,
                showSubmit: true
            }
            if (this.routeQuery.id) {
                row.parentId = this.routeQuery.id
            }
            this.vuexData.push(row)
            this.isReload()
        },
        isReload () {
            this.reload = false
            this.$nextTick(() => {
                this.reload = true
            })
        },
        adressChange(areaIdDesc, areaList, row){
            row.areaId = areaIdDesc ? areaIdDesc.join(',') : ''
            if(areaList){
                row.areaDesc = areaList
            }           
        },
        changeType(val, row){
            this.addressDescriptionOptions.forEach((e)=>{
                if(e.value == val.value){
                    row.addressDescriptionDesc = e.desc
                }
            })
        },
        // 选择地址
        selectArea (areaId, areaList) {
            if(areaId){
                this.dataForm.areaId = areaId.join(',')
                if(areaList){
                    this.dataForm.areaList = areaList.split('/')
                    if(this.dataForm.areaList[0].replace(' ', '') == '中国'){
                        this.required = true
                    }else{
                        this.required = false
                    }
                }
            }else{
                this.dataForm.areaId = undefined
                this.dataForm.areaList = undefined
                this.required = false
            }
        },
        //提交
        revise(){
            this.btnLoad.handLoad = true
            this.validate().then(()=>{
                this.dataForm.linkmanList = this.vuexData
                this.$post('/bas/client/basCustomer/submit', this.dataForm).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message.success(data.message)
                        if (this.$utils.getSessionStorage('isNewCustomer')) {
                            this.$utils.setSessionStorage('newCustomer', {
                                id: data.result, 
                                name: this.dataForm.name,
                            })
                            this.$utils.removeSessionStorage('isNewCustomer')
                            this.$router.push({
                                path: this.routeQuery.returnPath,
                                query: this.routeQuery
                            })
                        }else{
                            setTimeout(()=>{
                                this.$router.push({
                                    path: '/client-list',
                                })
                            }, 600)
                        }
                    }
                }).finally(() => {
                    this.btnLoad.handLoad = false
                })
            }).catch(()=>{
                this.btnLoad.handLoad = false
            })
        },
        // 校验函数
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.dataForm.validate((valid)=>{
                    if(valid){
                        this.$refs.elxEditable.validate(true).then(valid2 => {
                            if(!valid2){
                                return resolve()
                            }else{
                                return reject()
                            }
                        })
                    }else{
                        return reject()
                    }
                })
            })
        },
        //删除分录
        removeRow (row, index) {
            this.$confirm('确定删除该行数据?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.entryPrincipalId) {
                    row.action = 3
                    this.$post('/bas/client/basCustomer/delLinkman', row).then(({ data }) => {
                        if (data.code === 'C0000') {
                            this.$message.success(data.message)
                            if (!this.routeQuery.id) {
                                this.routeQuery.id =  data.result
                            }
                        }
                    })
                } else {
                    this.$refs.elxEditable.remove(row)
                }
                this.vuexData.splice(index, 1)
            })
        },
        //提交分类
        confirmRow(row){
            this.$refs.elxEditable.validate(row).then((valid) => {
                if(!valid){
                    this.$post('/bas/client/basCustomer/submitLinkman', row).then(({ data }) => {
                        if (data.code === 'C0000') {
                            this.$message.success(data.message)
                            this.init()
                        }
                    })
                }
            })
        },
        //临时附件
        updateBillsId (tempBillId) {
            this.dataForm.tempBillId = tempBillId || this.tempBillId
        },
        //返回
        back(){
            this.$router.push({
                path: '/client-list',
            })
        },
        // 默认地址切换
        switchDefault (row) {
            if (row.entryPrincipalId && ['已提交', '已审核'].includes(this.dataForm.statusDesc)) { // 已提交的数据
                this.$post('/bas/client/basCustomer/isDefaultChange', row).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message.success(data.message)
                    }
                }).finally(() => {
                    this.init()
                })
            } else if (row.isDefault) {
                this.customerTableData.map(item => {
                    if (item !== row) {
                        item.isDefault = 0
                    }
                })
            }
        },
        //同名客户
        nameBlur(){
            if(!this.dataForm.name) return
            this.$post('/bas/client/basCustomer/checkCustomer', { name: this.dataForm.name }).then(({ data }) => {
                if (data.code === 'C0000') {
                    if (data.result && ['已提交', '已审核'].includes(data.result.statusDesc)) {
                        this.$confirm('此客户名称已存在数据库，是否直接添加?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'info'
                        }).then(() => {
                            this.setCustomer(data.result)
                            this.revise()
                        }).catch(() => {
                            this.dataForm.name = ''
                        })
                    }
                }
            })
        },
        setCustomer(val){
            this.dataForm.number = val.number
            this.dataForm.isEnabled = val.isEnabled
            this.dataForm.name = val.name
            this.dataForm.uscCode = val.uscCode
            this.dataForm.shortName = val.shortName
            this.dataForm.areaIdDesc = val.areaIdDesc
            this.dataForm.areaId = val.areaId
            this.dataForm.address = val.address
            if (val.id) {
                this.dataForm.id = val.id
                this.routeQuery.id = val.id
            }
        },
        //根据收货地址判断
        takeAddressChangeInTable(value, row) {
            if (value) {
                this.queryOtherInTable(row)
            } else {
                
            }
        },
        queryOtherInTable(row){
            this.$post('/bas/client/basCustomer/checkCustomerLinkmanEntry', { takeAddress: row.takeAddress, parentId: this.dataForm.id }).then(({ data }) => {
                if (data.code === 'C0000' && data.result) {
                    row.isQuery = true
                    row.id = data.result.id
                    row.parentId = data.result.createById
                    row.createById = data.result.createById
                    row.createTime = data.result.createTime
                    row.updateById = data.result.updateById
                    row.updateTime = data.result.updateTime
                    row.addressType = data.result.addressType
                    row.areaId = data.result.areaId
                    row.areaIdDesc = data.result.areaIdDesc
                    row.areaDesc = data.result.areaDesc
                    row.entryPrincipalId = data.result.entryPrincipalId
                    row.addressDescription = data.result.addressDescription
                    row.company = data.result.company
                    row.linkman = data.result.linkman
                    row.mobile = data.result.mobile
                }else{
                    row.isQuery = false
                    row.id = ''
                }
            }).catch(()=>{
                row.isQuery = false
                row.id = ''
            })
        }   
    }
}
</script>

<style lang="scss">
    .client-detail{
        padding-top: 40px;
        color: #000000;
        font-weight: 400;
        background-color: #fff;
        .title-1{
            margin-bottom: 37px;
        }
        .title-3{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
        }
        h3{
            font-size: 18px;
            line-height: 18px;
        }
        .vxe-table{
            .vxe-table--header-wrapper{
                tr{
                    height: 45px;
                }
            }        
        }
        .addCargo{
            width: 100%;
            height: 45px;
            margin-bottom:38px ;
            padding-left: 22px;
            background-color: #F2F7FF;
            text-align: left;
            font-size: 14px;
            line-height: 45px;
            
            .icon-svg{
                width: 24px;
                height: 24px;
                vertical-align: middle;
                cursor: pointer;
            }
            span {
                display: inline-block;
                width: 90px;
                cursor: pointer;
            }
        }
    }
</style>